module.exports = __webpack_public_path__ + "static/media/banner_pc.0debfb93.jpg";